const initializeReactJsonSchemaFormData = (editorState, section) => {
  if (section) {
    Object.keys(section).forEach((key) => {
      const defaultValue = section[key].default ?? section[key].defaultValue ?? undefined;

      switch (section[key].type) {
        case 'object':
          editorState[key] = {};
          initializeReactJsonSchemaFormData(editorState[key], section[key].properties);
          break;
        case 'boolean':
          editorState[key] = defaultValue || false;
          break;
        case 'integer':
        case 'number': {
          if (defaultValue === 0) {
            editorState[key] = 0;
          } else {
            editorState[key] = defaultValue;
          }
          break;
        }
        case 'string':
          editorState[key] = defaultValue;
          break;
        case 'array':
          editorState[key] = defaultValue ? [defaultValue] : undefined;
          break;
        default:
          break;
      }
    });
  }
};

export default (schema) => {
  if (schema) {
    const editorState = {};
    initializeReactJsonSchemaFormData(editorState, schema.properties);
    return editorState;
  }

  return {};
};
